import { AnswerConfigurationResource as e } from "./configuration/AnswerConfiguration.js";
import { AnswerEvaluationResource as t } from "./evaluation/AnswerEvaluationResource.js";
import { AnswerRuleResource as n } from "./rule/AnswerRuleResource.js";
import { Resource as r } from "@coveo/platform-client";
// src/resources/answer/AnswerResource.ts
var i = class extends r {
	constructor(r, i) {
		super(r, i), this.configuration = new e(r, i), this.evaluation = new t(r, i), this.rule = new n(r, i);
	}
};
export { i as AnswerResource };

//# sourceMappingURL=AnswerResource.js.map